<template lang="pug">
  #app(@click.capture="navbarFocus = false")
    .wrapper
      LoaderOverlay(v-show="$store.state.loaderStack > 0")
      GlobalNotification
      Navbar(
        :focus.sync="navbarFocus"
        v-if="!blacklistedNavbarScreen && !printable")

      router-view#router-containaer
    Footer.footer-booter(v-if="!printable")
</template>

<script>
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import FormErrorAlert from './components/FormError'
import LoaderOverlay from './components/LoaderOverlay'
import GlobalNotification from './components/GlobalNotification'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    FormErrorAlert,
    LoaderOverlay,
    GlobalNotification,
  },
  data: function() {
    return {
      navbarFocus: false,
    }
  },
  computed: {
    // Is the current screen a screen that should be showing the navbar?
    blacklistedNavbarScreen() {
      return [
        'login',
        'verify',
        'complete_signup',
        'forgot_username',
        'forgot_password',
        'update_password',
      ].includes(this.$route.name)
    },
  },
}
</script>

<style lang="scss">
$footer-height: 200px;

html,
body {
  margin: 0;
  display: flex;
  width: 100%;
}

@media screen and (max-width: 980px) {
  body, #app {
    width: auto;
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.router-container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  > * {
    flex-grow: 1;
  }
}

.wrapper {
  min-height: calc(100vh - 200px);
}
</style>
